import { ref } from 'vue';

export const openMobileMenu = ref(null);
export const mmTopbar = ref(null);
